import React, { useState } from 'react';
import { Element } from 'react-scroll';
import { Collapse } from 'reactstrap';
import { useDesktop } from '../hooks';

const desktopClassName = (desktop: boolean): string =>
  desktop ? 'container-fluid bg-white pt30 pb30' : 'container-fluid bg-white';

const benefitsClassName = (collapse: boolean): string =>
  collapse
    ? 'col-12 border-bottom pt30 pb30 d-block d-md-none mb20'
    : 'col-12 border-bottom pt30 pb30 d-block d-md-none';

export default function ProductBenefits() {
  const desktop = useDesktop();
  const [collapse, setCollapse] = useState(desktop);

  const toggle = () => setCollapse(!collapse);

  return (
    <div className={desktopClassName(desktop)}>
      <div className="container">
        <div className="row">
          <div
            className={benefitsClassName(collapse)}
            onClick={toggle}
            role="presentation"
          >
            <i className="material-icons align-middle">keyboard_arrow_right</i>
            Beneficios
          </div>
          <Collapse className="col-12" isOpen={collapse}>
            <Element name="benefits" className="col-12">
              <h2 className="px-24 text-center mb40">
                Beneficios
              </h2>
            </Element>
            <div className="row">
              <ul className="col-12 col-md-4 d-flex flex-wrap text-primary mb0 li-custom li-check">
                <li className="col-12">
                  <p className="text-dark-gray">
                    Cobertura  Nacional.
                  </p>
                </li>
                <li className="col-12">
                  <p className="text-dark-gray">
                    Indemniza por día en caso de Hospitalización.
                  </p>
                </li>
                <li className="col-12">
                  <p className="text-dark-gray">
                    Sin límite de eventos (Hospitalización incluyendo recaídas).
                  </p>
                </li>
              </ul>
              <div className="col-8 col-md-4 text-center mb20 mt20 mx-auto d-none d-md-block">
                <img
                  className="img-fluid"
                  src="https://sfestaticos.blob.core.windows.net/otl/mexico/accidentes-personales/img/hospitalizacion.svg"
                  alt="Imagen persona hospitalizada"
                />
              </div>
              <ul className="col-12 col-md-4 d-flex flex-wrap text-primary mb0 li-custom li-check">
                <li className="col-12">
                  <p className="text-dark-gray">
                    Cubre enfermedades y accidentes.
                  </p>
                </li>
                <li className="col-12">
                  <p className="text-dark-gray">
                    Apoya económicamente a los beneficiaros en caso de Muerte Accidental.
                  </p>
                </li>
                <li className="col-12">
                  <p className="text-dark-gray">
                    Apoya en el pago de deducible y coaseguro a quienes cuentan con póliza de gastos médicos mayores.
                  </p>
                </li>
              </ul>
              <div className="col-8 mx-auto mt30 text-center d-block d-md-none">
                <img
                  className="img-fluid"
                  src="https://sfestaticos.blob.core.windows.net/otl/mexico/accidentes-personales/img/hospitalizacion.svg"
                  alt="Imagen persona hospitalizada"
                />
              </div>
              <div className="d-none d-sm-block w-100 mb30" />
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
}
